import type { RenderQuality } from '@rcs/renderer';

/** 描画品質の選択肢（低・中・高）。 */
export const QUALITY_OPTIONS: readonly RenderQuality[] = ['low', 'medium', 'high'];

/** 既定の描画品質。 */
export const DEFAULT_QUALITY: RenderQuality = 'medium';

/** 描画品質を保存する localStorage のキー。 */
export const QUALITY_STORAGE_KEY = 'rcs.settings.quality';

/** 値が描画品質なら返し、そうでなければ既定値（中）を返す。 */
export function parseQuality(value: unknown): RenderQuality {
  return QUALITY_OPTIONS.find((option) => option === value) ?? DEFAULT_QUALITY;
}

/** 保存先。`localStorage` の一部だけを使う（テストで差し替えられる）。 */
export type QualityStorage = Pick<Storage, 'getItem' | 'setItem'>;

/** 保存された描画品質を読む。保存がない・読めない・不正な値のときは既定値。 */
export function loadQuality(storage?: QualityStorage): RenderQuality {
  try {
    return parseQuality((storage ?? localStorage).getItem(QUALITY_STORAGE_KEY));
  } catch {
    // プライベートブラウズなどで localStorage を使えない場合は、保存なしで動く
    return DEFAULT_QUALITY;
  }
}

/** 描画品質を保存する。保存できなくても、アプリの動作には影響しない。 */
export function saveQuality(quality: RenderQuality, storage?: QualityStorage): void {
  try {
    (storage ?? localStorage).setItem(QUALITY_STORAGE_KEY, quality);
  } catch {
    // 保存できない環境では、その回の設定だけが有効になる
  }
}
